export enum EModuleConfigType {
  String = 'string',
  Boolean = 'bool',
  Array = 'array',
  Number = 'number',
  Int = 'int',
  Integer = 'integer'
}

export enum NAVIGATION_CONFIG {
  'connections',
  'previousModule'
}
